import Layout from '../components/Layout';
import Contact from '../components/Contact';

export default () => (
  <Layout>
    <div className="container">
      <h2 className="mb-30">Solutions</h2>
      <p>If you are interested in getting the best performance from your existing or new C++ library, we can offer quick proof-of-concept projects to gage possible benefits our tool can bring to you.</p>
      <ul className="unordered-list">
        <li>Proof-of-Concept projects</li>
        <li>Training in AAD mathematical concepts</li>
        <li>Training in AAD-C C++ Library</li>
        <li>Training in efficient parallel computing on modern CPU/GPU platforms</li>
      </ul>
      <Contact/>
    </div>
  </Layout>
)